import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import React from 'react'

import { CTAButtonWithWT } from '@f-fertighaus/applications/Next/components/common/CTAButton'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'

export const GalleryHouseImagesCtaBanner = () => {
  const {
    state: { vendor_nid, active }
  } = useHouseDetail()
  const isDisabled = !active

  return (
    <Wrapper>
      <Typography
        sx={{ marginBottom: 2 }}
        variant='body1'
        fontWeight='fontWeightBold'>
        {t('houseDetailPage.image_gallery.house_images.headline')}
      </Typography>
      <Typography variant='body1' sx={{ marginBottom: 3 }}>
        {t('houseDetailPage.image_gallery.house_images.contentText')}
      </Typography>
      <CTAButtonWithWT
        disabled={isDisabled}
        variant='contained'
        color='secondary'
        sx={{ marginRight: 'auto' }}
        wtPayload={{
          category: 'CTA-button',
          action: 'click',
          label: 'image-section-CTA',
          indicates: ['funnel-entry'],
          location: 'image-gallery',
          values: [
            {
              type: 'text',
              value: t('houseDetailPage.image_gallery.house_images.button_text')
            }
          ]
        }}
        data-request-type='house-detail-form'
        data-funnel-variant='house-wizard-item-infomaterial'
        {...(vendor_nid && { 'data-vendor-nid': vendor_nid })}
        className='js-request-button'>
        {t('houseDetailPage.image_gallery.house_images.button_text')}
      </CTAButtonWithWT>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin: ${({ theme }) => theme.spacing(3, 2)};
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin: ${({ theme }) => theme.spacing(3, 0)};
  }
`
